var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var button = require('../../components/button');
var dragscroll = require('../../libs/dragscroll');
var Model = require('../../libs/Model');
var modalForm = require('../../layout/components/modalForm');
var session = require('../../auth/models/session');

var pointDocument = modalForm(Object.assign(require('../../../../../models/documents/Document'), Model));

var dateFormat = 'MM/DD/YYYY';

var component = {};

component.oninit = function (vnode) {
  var ctrl = this;
  ctrl.point = vnode.attrs.pointRecord;
  ctrl.column = vnode.attrs.column;
  ctrl.loading = true;

  modal.on('closed', function () {
    ctrl.getDocuments();
  });

  ctrl.getDocuments = () => {
    return loaders.requestWithLoader({
      loader: 'background',
      url: '/api/v1/atachments/' + String(ctrl.point['@rid']).slice(1) ,
      method: 'GET',
      background: true,
    })
    .then(function (response) {
      ctrl.documents = response;
      ctrl.loading = false;
      m.redraw();
    })
  }
  ctrl.getDocuments();
};

component.view = function() {
  var ctrl = this
  if(ctrl.loading){
    return m("div.h5", {style: {opacity: 0.25}}, [
      m('img.loading', {src: '/images/loading-bars.svg'})
    ])
  }
  return m('div.mv1', [
    m('div.dragscroll-container', [
      m('div.dragscroll', {oncreate:dragscroll}, [
        m('table.fw2.f3.w-100.pr3', [
          m('thead', [
            m('tr.db.relative', [
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {'min-width': '280px'}},'Name'),
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {'width': '100%'}},'Description'),
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {'min-width': '160px'}},'Date Uploaded'),
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {'min-width': '160px'}},'Actions')
            ])
          ]),
          m('tbody.db', {style: {height: '16em'}}, [
            ctrl.documents.map(function (documentRecord) {
              return m('tr.db', [
                m('td.bb.tl.moon-gray.tl.nowrap', {style: {'min-width': '280px'}}, documentRecord.name),
                m('td.bb.tl.moon-gray.tl.nowrap', {style: {'width': '100%'}}, documentRecord.description),
                m('td.bb.tl.moon-gray.tl.nowrap', {style: {'min-width': '160px'}}, moment(parseInt(documentRecord.uploadedDate)).format(dateFormat)),
                m('td.bb.tl.moon-gray.tl.nowrap.tc', {style: {'min-width': '160px'}}, [
                  m('i.ion-ios-cloud-download.blue', {
                    style: {cursor: 'pointer'},
                    onclick: function () {
                      var param = encodeURIComponent(documentRecord.filename);
                      window.open( 
                        `/api/v1/getDocument?filename=${param}`, "_blank"); 
                      /*var param = encodeURIComponent(documentRecord.filename);               
                      fetch(`/api/v1/getDocument?filename=${param}`)
                      .then(resp => resp.blob())
                      .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        a.download = documentRecord.filename//+'.pdf'; // the filename
                        document.body.appendChild(a);
                        a.click(
                        window.URL.revokeObjectURL(url);
                      })
                      .catch((e) => console.log(e));*/
                    },
                  })
                ])
              ])
            })
          ])
        ])
      ])
    ]),
    m('div.cf', [
      session.user().isSuperuser ? m(button,{
          label:'Add Document',
          class: 'w5 mv4 fr',
          func:  pointDocument.editDialogue.bind(pointDocument, {parent: ctrl.point['@rid'].slice(1)}),
        })
      : ''
    ])
  ]);
}

module.exports = component;
